import { useMemo } from 'react'
import { Organization } from '../../../types'
import { useData } from '../contexts/DataContextProvider'
import styles from './Multiples.module.scss'
import MultiplesHeader from './MultiplesHeader'
import MultipleDotBars from './MultipleDotBars'

export default function Initiatives() {
  const { data, definitions } = useData()

  const dataByInitiative = useMemo(() => {
    const initiativeTypes = new Map<
      string,
      { name: string; orgs: Organization[] }
    >()
    definitions.forEach(({ id = '', display_label: name }) => {
      if (id.includes('initiative_type:')) {
        const type = id?.split(':')?.at(-1) || ''
        initiativeTypes.set(type, { name, orgs: [] })
      }
    })

    data
      .filter(({ initCommTask }) => initCommTask)
      .forEach((org) => {
        org?.initiative_type?.forEach((type) => {
          if (initiativeTypes.has(type)) {
            initiativeTypes.get(type)?.orgs.push(org)
          }
        })
      })

    return Array.from(initiativeTypes.entries())
      .map(([id, { name, orgs }]) => ({
        name,
        orgs,
      }))
      .sort(({ orgs: a }, { orgs: b }) => b.length - a.length)
  }, [data, definitions])

  return (
    <div className={`${styles.layout}`}>
      <MultiplesHeader
        title="Initiatives"
        copy={[
          'The advocacy and support of the movement has resulted in specific, place- or population focused reparations from government, faith-based, academic, and descendant communities.',
        ]}
      />

      <MultipleDotBars dataByMultiple={dataByInitiative} />
    </div>
  )
}
